import { PropType } from 'vue'

export default {
  /**
   * Max files number accepted by the Dropzone
   */
  maxFiles: {
    type: Number,
    default: null,
  },
  /**
   * Bytes value for the max upload size allowed
   */
  maxFileSize: {
    type: Number,
    default: 1000000,
  },
  /**
   * Element or query selector where the hidden Input it's placed
   */
  hiddenInputContainer: {
    default: 'body',
  },
  /**
   * If active enable the dropzone to be clickable and show the files selection
   */
  clickable: {
    type: Boolean,
    default: true,
  },
  /**
   * Array that contain the accepted files, possibile values:
   * ['image', 'doc', 'video', 'png', ... , 'audio' ]
   * for a full list see: TODO - place a link with the full accepted
   */
  acceptedFiles: {
    type: Array as PropType<string[]>,
    default: null,
  },
}
